import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */
class Prompt extends React.Component {
  static propTypes = {
    when: PropTypes.bool,
    message: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    callback: PropTypes.func,
    history: PropTypes.shape({
      block: PropTypes.func.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    when: true,
  };

  enable(message) {
    if (this.unblock) this.unblock();
    this.unblock = this.props.history.block(message);
  }

  disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  }

  close() {
    if (this.unblock) {
      this.props.callback && this.props.callback();
      this.disable();
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  }

  componentWillUnmount() {
    this.close();
  }

  render() {
    return null;
  }
}

export default withRouter(Prompt);
